<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;width:100%;">
      <div style="width:260px;float: left;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input
                maxlength="30"
                size="mini"
                style="width:220px;top:2px;"
                placeholder="姓名/手机号/微信号"
                v-model="searchQuery.key">
              </el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker v-model="searchQuery.dateRange1" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="画像更新时间">
              <el-date-picker v-model="searchQuery.dateRange9" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="订车时间">
              <el-date-picker v-model="searchQuery.dateRange2" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="交车时间">
              <el-date-picker v-model="searchQuery.dateRange3" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="跟进时间">
              <el-date-picker v-model="searchQuery.dateRange4" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="到店时间">
              <el-date-picker v-model="searchQuery.dateRange8" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="智驾时间">
              <el-date-picker v-model="searchQuery.dateRange7" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="战败时间">
              <el-date-picker v-model="searchQuery.dateRange5" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="休眠时间">
              <el-date-picker v-model="searchQuery.dateRange6" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="客户级别">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.level">
                <el-option v-for="item in levelOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="智慧评级">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.intelligentLevel">
                <el-option v-for="item in inLevelOptions" :key="item.dataName" :label="item.dataName"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否休眠">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.suspendStatus">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到店状态">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.comeStatus">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="自然到店" :value="1"></el-option>
                <el-option label="到店" :value="4"></el-option>
                <el-option label="邀约已到店" :value="2"></el-option>
                <el-option label="未到店" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否智驾">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.isSmartDrive">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否异地购车">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.isRemote">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
                <el-option label="空" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.fromType">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线上" :value="1"></el-option>
                <el-option label="线下" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线下来源" v-if="searchQuery.fromType == 2">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.fromSource" @change="fromSourceChange"
                ref="subject">
                <el-option v-for="item in fromSourceOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="自定义来源" v-if="searchQuery.fromType == 2 && searchQuery.fromSource == 99">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.otherSource" clearable>
                <el-option v-for="item in customizationList" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线上来源" v-if="searchQuery.fromType == 1">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.onlineSource">
                <el-option v-for="item in importSourceOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户经理" v-if="members.length > 1">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.member">
                <el-option v-for="item in members" :key="item.memberId" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购车类型">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.businessType">
                <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车系">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.series">
                <el-option v-for="item in seriesOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="微信客户" v-if="cityPoolEnable">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.wxCustomerStatus">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button
              :loading="listLoading"
              size="small"
              icon="el-icon-search"
              class="filter-item"
              @click="retrieveTables(false)"
            >筛选</el-button>
            <el-button size="small" icon="el-icon-refresh" class="filter-item" @click="reset">重置</el-button>
          </div>
        </div>
      </div>
      <div style="margin-left: 320px; overflow:auto;margin-right:20px;padding:0px 20px;">
        <h1 class="page_title">档案列表</h1>
        <div class="filter-container">
          <div style="margin-bottom: 10px;">
            <el-radio-group size="small" v-model="sortType" @change="retrieveTables(false)">
              <el-radio-button v-for="item in customerOrderOptions" :key="item.dataValue" :label="item.dataValue">{{
                item.dataDisplay }}</el-radio-button>
            </el-radio-group>
          </div>

          <el-button size="small" icon="el-icon-plus" class="filter-item" @click="showNewDialog">添加客户</el-button>
          <el-button size="small" icon="el-icon-sort" class="filter-item" @click="showAssignDialog"
            v-if="assignMembers.length > 0">再分配</el-button>
          <el-button size="small" v-if="isAdmin" icon="el-icon-upload2" class="filter-item"
            @click="showImportDialog">导入</el-button>
          <el-button size="small" v-if="isAdmin" icon="el-icon-download" class="filter-item"
            @click="getList(true)">导出</el-button>
          <el-checkbox v-model="searchQuery.isZk" style="margin-left:40px;background: #fff;" @change="zkChange"
            :true-label="1" :false-label="0" border size="small" v-if="isGroupBusiness">只看撞客</el-checkbox>
        </div>
        <el-table :data="tableRecords" stripe v-loading="listLoading" @selection-change="handleSelectionChange"
          @sort-change="sortChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column align="left" label="姓名" min-width="160">
            <template slot-scope="scope">
              <span class="click_link" @click="toDetailPage(scope.row.customerId)">
                {{ `${scope.row.name}${scope.row.mobile ? ` - ` : ""}`}}
                <Desensitize
                  v-if="scope.row.mobile"
                  :text="scope.row.mobile"
                  :userType="2"
                  :clearText="true"
                  :queryKey="scope.row.customerId"
                  :key="scope.row.customerId"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="客户经理" width="120">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="级别" width="120">
            <template slot-scope="scope">{{
              scope.row.level | levelDisplay
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="意向车系" min-width="200">
            <template slot-scope="scope">{{ scope.row.specName }}</template>
          </el-table-column>
          <el-table-column align="left" label="智慧评级" width="80">
            <template slot-scope="scope">{{ scope.row.intelligentLevel }}</template>
          </el-table-column>
          <el-table-column align="left" label="创建时间" width="160" sortable="custom">
            <template slot-scope="scope">{{ scope.row.createdDate }}</template>
          </el-table-column>
          <el-table-column align="left" label="最近跟进" width="160" sortable="custom">
            <template slot-scope="scope">{{ scope.row.updatedDate }}</template>
          </el-table-column>
          <el-table-column align="left" label="下次跟进" width="120">
            <template slot-scope="scope">
              <span v-show="scope.row.nextFollowDate !== ''">{{
                scope.row.nextFollowDate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="微信号" width="120" key="wechatId">
            <template slot-scope="scope">{{ scope.row.wechatId }}</template>
          </el-table-column>
          <el-table-column align="left" label="是否微信线索" width="120" key="isWechatClue">
            <template slot-scope="scope">{{ scope.row.isWechatClue ? '是' : '否' }}</template>
          </el-table-column>

          <!-- <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini">再分配</el-button>
                        </template>
                    </el-table-column>-->
        </el-table>
        <div class="pagination-container">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="添加客户" :visible.sync="newDialog" width="900px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="newForm" :inline="true" label-position="right" :model="newCustomer" :rules="newCustomerRules"
        label-width="95px">
        <div class="pure-g">
          <div class="add-title">客户信息</div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="姓名" prop="name">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.name" maxlength="30"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="手机号" prop="mobile">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.mobile"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="微信号">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.weixin"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="性别" prop="gender">
              <el-radio-group v-model="newCustomer.gender" size="mini">
                <el-radio-button :label="1">先生</el-radio-button>
                <el-radio-button :label="2">女士</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="上牌类型">
              <el-radio-group v-model="newCustomer.type" size="mini">
                <el-radio-button :label="1">个人</el-radio-button>
                <el-radio-button :label="2">企业</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="newCustomer.type == 2">
            <el-form-item class="form_item" label="企业名称" prop="companyName" :rules="newCustomer.type == 2
              ? newCustomerRules.companyName
              : newCustomerRules.notRequired
              ">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.companyName"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="客户来源">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.fromSource">
                <el-option v-for="item in newFromSourceOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="newCustomer.fromSource == 98 || newCustomer.fromSource == 99
            ">
            <el-form-item class="form_item" :label="newCustomer.fromSource == 98 ? '网络来源' : '自定义来源'">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.otherSource" clearable>
                <el-option v-for="item in customizationList" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="其他联系号码">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.secondardPhone"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-4" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="更多">
              <el-switch v-model="value1"></el-switch>
            </el-form-item>
          </div>
          <!-- class="pure-u-1-3"-->
          <div v-if="isNewMediaOffline" style="display: inline-block;width: 40%; padding-bottom:12px;letter-spacing: normal;">
            <el-form-item class="form_item" label="请上传客户来源凭证" label-width="167px" :prop="isNewMediaOffline ? 'newMediaImages' : ''">
              <Upload v-model="newCustomer.newMediaImages"></Upload>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-show="value1">
            <!-- <el-form-item class="form_item" label="所在地">
              <el-cascader
                v-model="home"
                :options="homeOptions"
                :props="props"
                size="small"
              ></el-cascader>
            </el-form-item> -->
            <el-form-item class="form_item" label="省/市/区">
              <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="provinceChange"
                v-model="newCustomer.addition.province">
                <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="cityChange"
                v-model="newCustomer.addition.city">
                <el-option v-for="item in citys" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择区" clearable v-model="newCustomer.addition.area">
                <el-option v-for="item in countys" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="联系地址">
              <el-input size="mini" style="width: 200px;" v-model="newCustomer.addition.address"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <!-- <el-form-item class="form_item" label="身份证">
              <el-input
                size="mini"
                style="width: 160px;"
                v-model="newCustomer.addition.idNo"
              ></el-input>
            </el-form-item> -->
            <el-form-item class="form_item" label="证件类型" prop="identifyType">
              <el-select size="mini" @change="identifyTypeChange" style="width:160px;" placeholder="请选择"
                v-model="newCustomer.identifyType">
                <el-option v-for="item in orderIdentifyTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" v-if="newCustomer.identifyType === 1" label="证件号码" prop="identifyNo">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="newCustomer.identifyNo"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="newCustomer.identifyType === 2" label="证件号码" prop="identifyNo2">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="newCustomer.identifyNo2"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="newCustomer.identifyType === 3" label="证件号码" prop="identifyNo3">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="newCustomer.identifyNo3"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="newCustomer.identifyType != 1 &&
              newCustomer.identifyType != 2 &&
              newCustomer.identifyType != 3
              " label="证件号码" prop="identifyNos">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="newCustomer.identifyNos"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="生日">
              <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.addition.birthday" :clearable="false"
                type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="QQ">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.addition.qq"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="pure-g">
          <div class="add-title">购车意向</div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向车系" prop="specIds">
              <el-select size="mini" style="width: 290px;" placeholder="选择意向车系" multiple :multiple-limit="5"
                v-model="newCustomer.specIds" filterable>
                <el-option v-for="item in seriesOptions" :key="item.specId" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向竞品">
              <el-select size="mini" style="width: 290px;" placeholder="选择意向竞品" multiple :multiple-limit="5"
                v-model="newCustomer.competitionSerieses" filterable>
                <el-option v-for="(item, index) in competitionSeriesesOptions" :key="index"
                  :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车类型">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.businessType">
                <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;"
            v-if="newCustomer.businessType == 2 || newCustomer.businessType == 3">
            <el-form-item class="form_item" label="原车信息">
              <el-select size="mini" style="width: 290px;" placeholder="选择原车信息"
                v-model="newCustomer.addPurchaseOldSeriesId" filterable>
                <el-option v-for="(item, index) in competitionSeriesesOptions" :key="index"
                  :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="newCustomer.businessType == 4">
            <el-form-item class="form_item" label="采购数量">
              <el-input-number size="mini" v-model="newCustomer.buyCount" :min="0" :max="10000"></el-input-number>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向级别">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.level" @change="changeLevel">
                <el-option v-for="item in followLevelOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2 buy-car-address" style="padding-bottom:12px;">
            <el-form-item class="form_item" prop="buyCarAddress">
              <div slot="label">
                <span style="color: #f56c6c;margin-right: 4px;">*</span>
                <span>购车地区</span>
                <el-popover
                  placement="top-start"
                  title=""
                  width="210"
                  trigger="hover"
                  content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                  <i slot="reference" style="margin-left: 5px;" class="el-icon-question"></i>
                </el-popover>
              </div>
              <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince"
                v-model="newCustomer.buyProvince">
                <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity"
                v-model="newCustomer.buyCity">
                <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="newCustomer.buyArea">
                <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车预算">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.budget">
                <el-option v-for="item in budgetOptions" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="预计购车时间">
              <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                v-model="newCustomer.buycarDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <div style="font-size: 13px;display:inline-block;height: 100%;line-height: 28px;">
              之前
            </div>
          </div>
        </div>
        <div class="pure-g">
          <div class="add-title">下次跟进计划</div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进方式">
              <el-radio-group size="small" v-model="newCustomer.nextActivityType">
                <el-radio-button v-for="item in activityNextFollowTypes" :key="item.dataValue" :label="item.dataValue">{{
                  item.dataDisplay }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                v-model="newCustomer.nextDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                v-model="newCustomer.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="confirmLoading" @click="doAdd" type="text">保存</el-button>
        <el-button @click="newDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="再分配" :visible.sync="assignDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="assignForm" label-position="left" :model="assignForm" :rules="assignFormRules" label-width="80px">
        <el-form-item class="form_item_val" label="客户经理" prop="memberId">
          <el-select size="mini" v-model="assignForm.memberId">
            <el-option v-for="item in assignMembers" :key="item.memberId" :label="item.userName"
              :value="item.memberId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form_item_val" label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入备注内容" v-model="assignForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="confirmLoading" @click="doAssign" type="text">确定</el-button>
        <el-button @click="assignDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="客户导入" :visible.sync="importDialog" width="550px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div style="text-align:center;">
        <el-upload class="upload-demo" accept=".xlsx" drag action :file-list="uploadFiles" :http-request="uploadRequest"
          :limit="1" :on-success="uploadSuccess" :on-remove="uploadRemove" :before-upload="uploadBefore">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/template/%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88_v1.1.xlsx"
            class="click_link">下载模版</a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="uploadLoading" :disabled="uploadLoading" @click="doImport" type="text">{{ uploadLoading ?
          "导入中..." : "确定" }}</el-button>
        <el-button @click="hideImportDialog" v-show="!uploadLoading" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="客户提醒" :visible.sync="tipDialog" width="400px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div>
        此手机号{{
          newCustomer.mobile
        }}已存在于企业微信客户池，创建档案后默认领取该客户，请知晓。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipDialog = false" type="text">我已知晓</el-button>
      </span>
    </el-dialog>

    <!-- blc拦截弹窗 -->
    <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
  </div>
</template>

<script>
import oss from '../../assets/js/ali-oss';
import BlcTips from "@/components/blc-tips/index.vue";
import Upload from "@/components/common/Upload.vue";
import { getUrls } from '@/assets/js/util'
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var customer_list_vm;
export default {
  components: { BlcTips, Upload, Desensitize },
  data() {
    const validateIdentifyNo = (rule, value, callback) => {
      //15位和18位身份证号码的正则表达式
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = value.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          }
        }
      } else {
        callback(new Error("请输入合法证件号"));
      }
    };
    const validateBuyCarAddress = (rule, value, callback) => {
      const [buyProvince, buyCity] = value
        if (!!buyProvince&&!!buyCity) {
            callback();
        } else {
            callback(new Error("请选择购车地区"));
        }
    }
    customer_list_vm = this;
    return {
      showBlcTips: false,
      blcInfo: {},
      tipDialog: false,
      listLoading: false,
      dealer: this.$common.getLoginInfo().profile,
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      isGroupBusiness: this.$common.getLoginInfo().isGroupBusiness,
      home: [], //所在地
      props: {
        value: "city",
        label: "city",
        children: "cities",
      },
      searchQuery: {
        suspendStatus: "",
        comeStatus: "",
        key: "",
        levelType: "",
        fromType: 0,
        dateRange1: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 29).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ],
        dateRange2: null,
        dateRange3: null,
        dateRange4: null,
        dateRange5: null,
        dateRange6: null,
        dateRange7: null,
        dateRange8: null,
        dateRange9: null,
        level: [],
        intelligentLevel: [],
        member: [],
        fromSource: "",
        otherSource: "",
        onlineSource: [],
        businessType: [],
        series: [],
        isZk: 0,
        isSmartDrive: "",
        isRemote: null,
        wxCustomerStatus: ''
      },
      sortType: 0,

      tableRecords: [],
      multipleSelection: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      customerOrderOptions: [
        { dataDisplay: "全部", dataValue: 0 },
        { dataDisplay: "未到店", dataValue: 1 },
        { dataDisplay: "已到店", dataValue: 2 },
        { dataDisplay: "订车", dataValue: 3 },
        { dataDisplay: "成交", dataValue: 4 },
        { dataDisplay: "战败", dataValue: 5 },
        { dataDisplay: "休眠", dataValue: 6 },
      ],
      fromSourceOptions: [],
      importSourceOptions: [],
      businessTypeOptions: [],
      levelOptions: [],
      followLevelOptions: [],
      intelligentLevelOptions: [], // 海洋智慧评级
      dynastyLevelOptions: [ // 王朝智慧评级
        { dataName: '低' },
        { dataName: '中' },
        { dataName: '高' },
        { dataName: '空' },
      ],
      budgetOptions: [],
      activityNextFollowTypes: [],
      homeOptions: [],
      members: [],

      newDialog: false,
      newCustomer: {
        name: "",
        mobile: "",
        weixin: "",
        gender: "",
        newMediaImages: [],
        type: 1,
        companyName: "",
        fromSource: 1,
        otherSource: "",
        secondardPhone: "",
        specIds: [],
        competitionSerieses: [],
        budget: 1,
        businessType: 1,
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        buycarDate: "",
        nextTestSpecId: "",
        remark: "",
        buyCount: "",
        buyCarAddress: [],//购车地区-省市区
        buyProvince: '',// 购车地区-省
        buyCity: '',// 购车地区-市
        buyArea: '',// 购车地区-区
        identifyType: 1,
        // idNo: "",
        identifyNo: "",
        identifyNo2: "",
        identifyNo3: "",
        identifyNos: "",
        addition: {
          province: "",
          city: "",
          area: "",
          address: "",
          birthday: "",
          qq: "",
        },
        addPurchaseOldSeriesId: ''
      },
      newCustomerRules: {
        name: [
          {
            required: true,
            message: "请输入客户姓名",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        newMediaImages: [
          {
            type: "array",
            required: true,
            message: "请上传客户来源凭证",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        specIds: [
          {
            required: true,
            message: "请选择意向车系",
            trigger: "change",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        buyCarAddress: [
          {
            // type: 'array',
            required: true,
            message: "请选择购车地区",
            trigger: "change",
            validator: validateBuyCarAddress,
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ]
      },
      seriesOptions: [],

      assignDialog: false,
      assignForm: {
        memberId: "",
        remark: "",
      },
      assignFormRules: {
        memberId: [
          {
            required: true,
            message: "请选择客户经理",
            trigger: "blur",
          },
        ],
      },
      baseInfo: {},
      importDialog: false,
      uploadFiles: [],
      uploadFile: "",
      uploadLoading: false,
      confirmLoading: false,
      orderType: 0,
      value1: false, // 更多
      competitionSeriesesOptions: [],
      assignMembers: [],
      customizationList: [],
      provinces: [],// 省份
      citys: [],// 省/市/区 - 城市列表
      countys: [],// 省/市/区   --区域列表
      buyCarCityList: [],// 购车地区-城市列表
      buyCarAreaList: [],// 购车地区-城市列表
      orderIdentifyTypeDics: [], // 证件类型
      cityPoolEnable: false,
      dealerProvince: '',// 门店所在省份
      dealerCity: '',// 门店所在市
      dealerArea: '',// 门店所在区
      newMediaSource: [], // 新媒体来源配置
    };
  },
  filters: {
    levelDisplay(level) {
      for (var i = 0; i < customer_list_vm.levelOptions.length; i++) {
        var o = customer_list_vm.levelOptions[i];
        if (o.dataName == level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.startWith("/customer/detail/")) {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters"));
          vm.searchQuery = listFilters.searchQuery;
          vm.sortType = listFilters.sortType;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) {
          console.log(error)
         }
      }
      vm.getList();
    });
  },
  created() {
    this.baseInfo = this.$common.getBaseInfo();
    var loginInfo = this.$common.getLoginInfo();
    this.cityPoolEnable = loginInfo.cityPoolEnable;
    this.fromSourceOptions = this.baseInfo.customerFromSources;
    this.importSourceOptions = this.baseInfo.importSources;
    this.businessTypeOptions = this.baseInfo.businessTypes;
    this.followLevelOptions = this.baseInfo.customerFollowLevels;
    this.budgetOptions = this.baseInfo.budgets;
    this.newMediaSource = this.baseInfo.newMediaSource
    this.budgetOptions.forEach((item) => {
      item.dataDisplay = item.dataDisplay + "万元";
    });
    this.activityNextFollowTypes = this.baseInfo.activityNextFollowTypes;
    this.levelOptions = this.baseInfo.customerLevels;
    this.intelligentLevelOptions = this.baseInfo.intelligentLevels;
    this.homeOptions = this.baseInfo.cities;
    this.homeOptions.forEach((item) => {
      item.city = item.province;
    });
    this.orderIdentifyTypeDics = this.baseInfo.orderIdentifyTypeDics;
    this.retrieveMembers();
    this.retrieveSeriesOptions();
    this.getCompetitionSeriesesOptions();
    this.getcustomizationList();
    this.getProvinces();
  },
  computed: {
    newFromSourceOptions() {
       if (!this.baseInfo || !Array.isArray(this.baseInfo.customerFromSources)) {
            return [];
        }
        // 去掉跨品牌转介绍和新媒体的客户来源
        return this.baseInfo.customerFromSources.filter((item) => item.dataDisplay != '跨品牌转介绍' && item.dataDisplay != '新媒体')
    },
    // 新媒体来源 抖音-店端、快手-店端、微信视频号-店端、小红书-店端 [100, 102, 105, 101]
    isNewMediaOffline() {
      return this.newMediaSource.some(n => n.dataValue === this.newCustomer.fromSource) 
    },
    // 海洋门店 type 1王朝 2海洋
    isOceanCDP() {
      return this.dealer.type === 2
    },
    inLevelOptions() {
      return this.isOceanCDP ? this.intelligentLevelOptions : this.dynastyLevelOptions
    }
  },
  methods: {
    identifyTypeChange() {
      this.newCustomer.identifyNo = "";
      this.newCustomer.identifyNo2 = "";
      this.newCustomer.identifyNo3 = "";
      this.newCustomer.identifyNos = "";
    },
    // 省改变
    provinceChange(provinceName) {
      this.getCityList(provinceName).then(res => {
        this.citys = res.data.data;
        this.newCustomer.addition.city = "";
        this.newCustomer.addition.area = "";
      })
    },
    // 市改变
    cityChange(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.newCustomer.addition.province,
        city:cityName
      }
      this.getAreaList(params).then(res => {
        this.countys = res.data.data;
        this.newCustomer.addition.area = "";
      })
    },
    // 获取区
    getAreaList(params) {
      return new Promise((resolve,reject) => {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", params)
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取市
    getCityList(provinceName) {
      return new Promise((resolve,reject)=> {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: provinceName,
          city: "",
        })
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
          this.dealerProvince = res.data.province;
          this.dealerCity = res.data.city;
          this.dealerArea = res.data.county;
        });
    },
    // 改变购车地区省
    changeBuyCarProvince(provinceName) {
      this.newCustomer.buyCity = "";
      this.newCustomer.buyArea = "";
      this.buyCarCityList = [] // 清除市列表
      this.buyCarAreaList = [] // 清除区列表
      if (provinceName) {
        this.getCityList(provinceName).then(res => {
          this.buyCarCityList = res.data.data;
        })
        this.newCustomer.buyCarAddress = [provinceName]// 重置选择项
      } else {
        this.newCustomer.buyProvince = "";
        this.newCustomer.buyCarAddress = []// 重置选择项
      }
    },
    // 改变购车城市
    changeBuyCarCity(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.newCustomer.buyProvince,
        city:cityName
      }
      this.newCustomer.buyArea = "";// 清除区
      this.buyCarAreaList = []// 清除区列表
      // 选择区域
      if (cityName) {
        // 获取区域
        this.getAreaList(params).then(res => {
          this.buyCarAreaList = res.data.data;
        })
        this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0],cityName]// 重置选择项
      } else {
        // 清空市
        this.newCustomer.buyCity = "";// 清除市
        this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0]]// 重置选择项
      }
    },
    // 改变购车地区区域
    changeBuyCarArea(areaName) {
      if (!!areaName) {
        this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1], areaName]// 更新选择项
      } else {
        this.newCustomer.buyArea = "";
        this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1]]// 重置选择项
      }
      this.$forceUpdate()
    },
    fromSourceChange(val) {
      if (val == 99) {
        this.$refs.subject.blur();
      }
    },
    zkChange() {
      this.retrieveTables(false);
    },
    // 其他来源数据
    getcustomizationList() {
      this.$httpAuth
        .post("/v2/appDealerManagerService/sourceList", {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.customizationList = res.data.data;
        });
    },
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.members = response.data.data;
          if (!parent.isAdmin) {
            parent.members.push({
              memberId: parent.dealer.userId,
              userName: parent.dealer.name,
            });
          }

          parent.assignMembers = [];
          for (var i = 0; i < parent.members.length; i++) {
            var o = parent.members[i];
            if (parent.isAdmin) {
              if (o.memberId != parent.dealer.userId) {
                parent.assignMembers.push(o);
              }
            }
          }
        });
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        });
    },
    retrieveTables(type) {
      this.listQuery.page = 1;
      this.getList(type);
    },
    // 重置
    reset() {
      this.orderType = 0;
      this.searchQuery = {
        suspendStatus: "",
        comeStatus: "",
        key: "",
        levelType: "",
        fromType: 0,
        dateRange1: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 29).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ],
        dateRange2: null,
        dateRange3: null,
        dateRange4: null,
        dateRange5: null,
        dateRange6: null,
        dateRange7: null,
        dateRange8: null,
        dateRange9: null,
        level: [],
        intelligentLevel: [],
        member: [],
        fromSource: "",
        otherSource: "",
        onlineSource: [],
        businessType: [],
        series: [],
        isZk: 0,
        isSmartDrive: "",
        isRemote: null,
        wxCustomerStatus: ''
      };
      this.retrieveTables(false);
      this.confirmLoading = false;
    },
    getCompetitionSeriesesOptions() {
      var that = this;
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: that.dealer.dealerId,
          key: "",
        })
        .then(function (res) {
          that.competitionSeriesesOptions = res.data.data;
        });
    },
    // 表格上的排序
    sortChange(data) {
      if (data.column && data.column.label == "创建时间") {
        if (data.order == "ascending") {
          this.orderType = 1;
        } else {
          this.orderType = 0;
        }
      } else if (data.column && data.column.label == "最近跟进") {
        if (data.order == "ascending") {
          this.orderType = 3;
        } else {
          this.orderType = 2;
        }
      } else if (data.column == null) {
        this.orderType = 0;
      }
      this.getList();
    },
    // 获取列表数据
    getList(type) {
      if (this.searchQuery.fromType == 1) {
        this.searchQuery.fromSource = "";
      } else if (this.searchQuery.fromType == 2) {
        this.searchQuery.onlineSource = [];
      } else {
        this.searchQuery.fromSource = "";
        this.searchQuery.onlineSource = [];
      }
      if (this.searchQuery.fromSource != 99 || this.searchQuery.fromType != 2) {
        this.searchQuery.otherSource = "";
      }
      let params = {
        dealerId: this.dealer.dealerId,
        type: this.sortType,
        saleIds: this.searchQuery.member.join(","),
        levels: this.searchQuery.level.join(","),
        intelligentLevels: this.searchQuery.intelligentLevel.join(","),
        createdDate: {
          start:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[0]
              : "",
          end:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[1]
              : "",
        },
        orderDate: {
          start:
            this.searchQuery.dateRange2 != null
              ? this.searchQuery.dateRange2[0]
              : "",
          end:
            this.searchQuery.dateRange2 != null
              ? this.searchQuery.dateRange2[1]
              : "",
        },
        deliverDate: {
          start:
            this.searchQuery.dateRange3 != null
              ? this.searchQuery.dateRange3[0]
              : "",
          end:
            this.searchQuery.dateRange3 != null
              ? this.searchQuery.dateRange3[1]
              : "",
        },
        followDate: {
          start:
            this.searchQuery.dateRange4 != null
              ? this.searchQuery.dateRange4[0]
              : "",
          end:
            this.searchQuery.dateRange4 != null
              ? this.searchQuery.dateRange4[1]
              : "",
        },
        comeDate: {
          start:
            this.searchQuery.dateRange8 != null
              ? this.searchQuery.dateRange8[0]
              : "",
          end:
            this.searchQuery.dateRange8 != null
              ? this.searchQuery.dateRange8[1]
              : "",
        },
        failDate: {
          start:
            this.searchQuery.dateRange5 != null
              ? this.searchQuery.dateRange5[0]
              : "",
          end:
            this.searchQuery.dateRange5 != null
              ? this.searchQuery.dateRange5[1]
              : "",
        },
        suspendDate: {
          start:
            this.searchQuery.dateRange6 != null
              ? this.searchQuery.dateRange6[0]
              : "",
          end:
            this.searchQuery.dateRange6 != null
              ? this.searchQuery.dateRange6[1]
              : "",
        },
        smartDriveDate: {
          start:
            this.searchQuery.dateRange7 != null
              ? this.searchQuery.dateRange7[0]
              : "",
          end:
            this.searchQuery.dateRange7 != null
              ? this.searchQuery.dateRange7[1]
              : "",
        },
        cdpTagUpdateDate: {
          start:
            this.searchQuery.dateRange9 != null
              ? this.searchQuery.dateRange9[0]
              : "",
          end:
            this.searchQuery.dateRange9 != null
              ? this.searchQuery.dateRange9[1]
              : "",
        },
        suspendStatus:
          this.searchQuery.suspendStatus == ""
            ? 0
            : this.searchQuery.suspendStatus,
        comeStatus:
          this.searchQuery.comeStatus == "" ? 0 : this.searchQuery.comeStatus,
        isSmartDrive:
          this.searchQuery.isSmartDrive == ""
            ? 0
            : this.searchQuery.isSmartDrive,
        isRemote: this.searchQuery.isRemote,
        key: this.searchQuery.key,
        fromType: this.searchQuery.fromType,
        fromSources: this.searchQuery.fromSource + "",
        otherSource: this.searchQuery.otherSource + "",
        onlineSources: this.searchQuery.onlineSource.join(","),
        businessTypes: this.searchQuery.businessType.join(","),
        series: this.searchQuery.series.join(","),
        payType: 0,
        failReason: 0,
        resumeDuration: 0,
        orderType: this.orderType,
        isZk: this.searchQuery.isZk,
        isExport: type,
        wxCustomerStatus: this.searchQuery.wxCustomerStatus === '' ? 0 : this.searchQuery.wxCustomerStatus,
      };
      if (type) {
        const loading = this.$loading({
          lock: true,
          text: "正在导出中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$exportAuth
          .post("/v2/appCustomerService/list", params)
          .then((response)=> {
            const { file, total } = response.data
            if (total > 2000) {
              this.$message({
                customClass: 'export-message',
                dangerouslyUseHTMLString: true,
                message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                duration: 2000
              })
            }
            setTimeout(() => {
              loading.close();
              var a = document.createElement("a");
              a.href = file;
              a.click();
            }, 1000);
          })
          .catch(() => {
            loading.close();
          });
      } else {
        if (this.listLoading) return
        this.listLoading = true;
        this.$httpAuth
          .post("/v2/appCustomerService/list", {
            ...params,
            pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
            pageCount: this.listQuery.limit,
          })
          .then(res => {
            const { data=[], total=0 } = res?.data ?? {}
            this.tableRecords = data
            this.total = total
          }).finally(() => {
            this.listLoading = false
          })
      }
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.newCustomer.level) {
          days = o.dataValue;
          break;
        }
      }
      this.newCustomer.nextDate = this.$common.addDate(new Date(), days);
    },
    // 添加客户弹框
    showNewDialog() {
      this.home = [];
      this.newCustomer = {
        name: "",
        mobile: "",
        weixin: "",
        gender: "",
        newMediaImages: [],
        type: 1,
        companyName: "",
        fromSource: 1,
        otherSource: "",
        secondardPhone: "",
        specIds: [],
        competitionSerieses: [],
        budget: 1,
        businessType: 1,
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        buycarDate: "",
        nextTestSpecId: "",
        remark: "",
        buyCount: 0,
        buyCarAddress: [this.dealerProvince, this.dealerCity, this.dealerArea],//购车地区
        buyProvince: this.dealerProvince,// 门店所在省份
        buyCity: this.dealerCity,// 门店所在市
        buyArea: this.dealerArea,// 门店所在区
        identifyType: 1,
        idNo: "",
        identifyNo2: "",
        identifyNo3: "",
        identifyNos: "",
        addition: {
          province: "",
          city: "",
          area: "",
          address: "",
          birthday: "",
          qq: "",
        },
        axiosTimes: 0,
        addPurchaseOldSeriesId: '',
      };
      this.changeLevel();
      this.newDialog = true;
      this.confirmLoading = false;
      this.buyCarCityList = [] // 清除市列表
      this.buyCarAreaList = [] // 清除区列表
      this.$nextTick(() => {
        this.$refs.newForm.clearValidate()
      })
      if (this.dealerProvince) {
        this.getCityList(this.dealerProvince).then(res => {
          this.buyCarCityList = res.data.data;
        })
      }
      if (this.dealerCity) {
        this.getAreaList({
          dealerId: this.dealer.dealerId,
          province: this.dealerProvince,
          city: this.dealerCity
        }).then(res => {
          this.buyCarAreaList = res.data.data;
        })
      }
    },
    // 确定添加客户
    doAdd() {
      if (new Date().getTime() / 1000 - this.axiosTimes < 2) {
        return;
      }
      this.axiosTimes = new Date().getTime() / 1000;
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          if (
            this.newCustomer.fromSource == 99 &&
            !this.newCustomer.otherSource
          ) {
            this.$message({
              message: "请选择自定义来源",
              type: "warning",
            });
            return;
          }
          // var parent = this;
          // 购车地区
          const [buyProvince, buyCity, buyArea=''] = this.newCustomer.buyCarAddress
          let params = {
            dealerId: this.dealer.dealerId,
            name: this.newCustomer.name,
            mobile: this.newCustomer.mobile,
            weixin: this.newCustomer.weixin,
            gender: this.newCustomer.gender,
            newMediaImages: this.isNewMediaOffline ? getUrls(this.newCustomer.newMediaImages).join(',') : '',
            type: this.newCustomer.type,
            companyName: this.newCustomer.companyName,
            fromSource: this.newCustomer.fromSource,
            otherSource: this.newCustomer.otherSource + "",
            addition: {
              province: this.newCustomer.addition.province,
              city: this.newCustomer.addition.city,
              area: this.newCustomer.addition.area,
              address: this.newCustomer.addition.address,
              idNo: "",
              identifyType: this.newCustomer.identifyType,
              birthday: this.newCustomer.addition.birthday,
              qq: this.newCustomer.addition.qq,
            },
            secondardPhone: this.newCustomer.secondardPhone,
            tags: "",
            level: this.newCustomer.level,
            specIds: this.newCustomer.specIds.join(","),
            competitionSerieses: this.newCustomer.competitionSerieses.join(","),
            budget: this.newCustomer.budget,
            nextActivityType: this.newCustomer.nextActivityType,
            nextDate: parseInt(this.newCustomer.nextDate.getTime() / 1000),
            buycarDate:
              this.newCustomer.buycarDate != ""
                ? parseInt(this.newCustomer.buycarDate.getTime() / 1000)
                : 0,
            nextTestSpecId: +this.newCustomer.nextTestSpecId,
            isRepace: true,
            businessType: this.newCustomer.businessType,
            customSource: this.newCustomer.customSource,
            buyCount: this.newCustomer.buyCount,
            buyProvince,
            buyCity,
            buyArea,
            remark: this.newCustomer.remark,
            newType: 0,
            addPurchaseOldSeriesId: this.newCustomer.addPurchaseOldSeriesId === '' ? 0 : this.newCustomer.addPurchaseOldSeriesId,
          };
          if (this.newCustomer.identifyType === 1) {
            params.addition.idNo = this.newCustomer.identifyNo;
          } else if (this.newCustomer.identifyType === 2) {
            params.addition.idNo = this.newCustomer.identifyNo2;
          } else if (this.newCustomer.identifyType === 3) {
            params.addition.idNo = this.newCustomer.identifyNo3;
          } else {
            params.addition.idNo = this.newCustomer.identifyNos;
          }
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/add", params)
            .then(response=>{
              if (response.data.code == 202 && response.data.status== -2) {
                this.blcInfo = {
                  name: params.name,
                  mobile: params.mobile,
                  idNo: params.addition.idNo,
                  detail: response.data.detail
                }
                this.showBlcTips = true;
                return;
              }
              if (response.data.weixinClueExisted) {
                this.tipDialog = true;
              }
              this.newDialog = false;
              this.retrieveTables(false);
              this.confirmLoading = false;
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    // 再分配弹框
    showAssignDialog() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择再分配客户",
          type: "warning",
        });
        return;
      }
      this.assignForm = {
        memberId: "",
        remark: "",
      };
      if (this.$refs["assignForm"]) {
        this.$refs["assignForm"].resetFields();
      }
      this.assignDialog = true;
      this.confirmLoading = false;
    },
    // 确定再分配
    doAssign() {
      var ids = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var o = this.multipleSelection[i];
        ids.push(o.customerId);
      }
      this.$refs["assignForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v1/customerRpc/batchReassign", {
              dealerId: this.dealer.dealerId,
              customerIds: ids.join(","),
              memberId: this.assignForm.memberId,
              remark: this.assignForm.remark,
            })
            .then(function (response) {
              parent.$message(
                response.data.successTotal + " 位客户再分配成功!"
              );
              parent.assignDialog = false;
              parent.retrieveTables(false);
              parent.multipleSelection = [];
            })
            .catch(() => { });
        }
      });
    },
    toDetailPage(id) {
      var listFilters = {
        searchQuery: this.searchQuery,
        sortType: this.sortType,
        total: this.total,
        listQuery: this.listQuery,
      };
      sessionStorage.setItem("type", null);
      sessionStorage.setItem("listFilters", JSON.stringify(listFilters));
      this.$router.push({
        path: "/customer/detail/" + id,
      });
    },
    showImportDialog() {
      this.importDialog = true;
      this.uploadLoading = false;
      this.confirmLoading = false;
    },
    hideImportDialog() {
      this.uploadFiles = [];
      this.uploadFile = "";
      this.importDialog = false;
      this.confirmLoading = false;
    },
    uploadBefore(file) {
      if (file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请上传xlsx格式文件!')
        return false;
      }
    },
    uploadRequest(option) {
      oss.ossUploadFile(option)
    },

    uploadSuccess(res) {
      this.uploadFile = res;
    },

    uploadRemove() {
      this.uploadFile = "";
    },
    doImport() {
      if (this.uploadFile == "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      this.uploadLoading = true;
      this.$httpAuth
        .post("/v1/customerRpc/import", {
          dealerId: this.dealer.dealerId,
          file: this.uploadFile,
        })
        .then(res => {
          const { successTotal, duplicateTotal, failTotal, failReasons=[] } = res?.data ?? {}
          const  importResultStr = `<div>创建成功 ${successTotal}条 客户数据</div>
            <div>重复未能插入 <span style="color:red;">${duplicateTotal}条</span> 客户数据</div>
            <span>失败 <span style="color:red;">${failTotal}条</span> 数据</span>`
          let failReasonStr = "";
          if (failTotal > 0) {
            const initStr = "<span>，失败原因如下：</span> <br>"
            failReasonStr = failReasons.reduce((calc, e, index) => {
              calc += `<div>${index+1}、${e}</div>`
              return calc
            }, initStr)
          }
          this.$notify({
            title: "客户导入结果",
            dangerouslyUseHTMLString: true,
            message: importResultStr + failReasonStr
          }) 
          this.hideImportDialog();
          this.reset();
        })
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$httpAuth
        .post("/v1/customerRpc/list", {
          dealerId: this.dealer.dealerId,
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          saleIds: this.searchQuery.member.join(","),
          levels: this.searchQuery.level.join(","),
          intelligentLevels: this.searchQuery.intelligentLevel.join(","),
          key: this.searchQuery.key,
          orderBy: this.sortType,
          formType: this.searchQuery.fromType,
          isPublic: false,
          fromSource: this.searchQuery.fromSource.join(","),
          onlineSource: this.searchQuery.onlineSource.join(","),
          businessType: this.searchQuery.businessType.join(","),
          dateStart: Math.round(
            new Date(
              this.searchQuery.dateRange1[0].replace(/-/, "/")
            ).getTime() / 1000
          ),
          dateEnd: Math.round(
            new Date(
              this.searchQuery.dateRange1[1].replace(/-/, "/")
            ).getTime() / 1000
          ),
          series: this.searchQuery.series.join(","),
          isZk: this.searchQuery.isZk,
          isExport: true,
        })
        .then(function (response) {
          console.log(response.data);
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
.add-title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.el-pagination .more+.number {
  display: none !important;
}
.buy-car-address /deep/.el-form-item__label::before{
  display: none;
}
</style>
